import {
    Box,
    Container,
    Grid,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Stack,
    Typography,
    IconButton,
    useTheme,
  } from "@mui/material";
  import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
  import PlayCircleOutline from "@mui/icons-material/PlayCircleOutline";
  import ModalVideo from "../ModalVideo/ModalVideo";
  import React, { useEffect, useState } from "react";
  import AOS from "aos";
  import "aos/dist/aos.css";
  import useSectionView from "../hook/useSectionView";
  
  const dataLista = [
    { id: 1, texto: "En la capacitación y actualización continua de todo el personal para la mejora continua." },
    { id: 2, texto: "Alcanzar altos niveles de eficacia y eficiencia en los procesos y productos al costo más razonable." },
    { id: 3, texto: "Responder satisfactoriamente al cliente, utilizando un sistema sencillo que garantice fluidas comunicaciones." },
  ];
  
  const About = () => {
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const sectionRef = useSectionView("Nosotros");

    useEffect(() => {
      AOS.init({ once: true });
    }, []);

    return (
      <section id="Nosotros" aria-labelledby="about-heading" ref={sectionRef}>
        <Box
          sx={{
            position: "relative",
            backgroundImage: "url(/assets/images/logosintranparencia.png)", // desde public/
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundAttachment: { xs: "scroll", md: "fixed" },
          }}
        >
          {/* Overlay para contraste */}
          <Box
            aria-hidden
            sx={{
              position: "absolute",
              inset: 0,
              background: "linear-gradient(to bottom, rgba(255,255,255,.9), rgba(255,255,255,.95))",
            }}
          />

          {/* Ola decorativa: suaviza el corte entre el hero y esta sección */}
          <Box
            aria-hidden
            component="svg"
            viewBox="0 0 1440 100"
            preserveAspectRatio="none"
            sx={{
              display: "block",
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: { xs: 36, sm: 56, md: 80 },
              transform: "translateY(-99%)",
            }}
          >
            <path fill="#fbfcfe" d="M0,64L80,58.7C160,53,320,43,480,48C640,53,800,75,960,80C1120,85,1280,75,1360,69.3L1440,64L1440,100L0,100Z" />
          </Box>

          <Container
            maxWidth="lg"
            sx={{
              position: "relative",
              py: { xs: 6, md: 10 },
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Stack>
              <Typography
                id="about-heading"
                variant="h4"
                sx={{ color: theme.palette.primary.main, fontWeight: "bold", mb: 2, textAlign: "center" }}
              >
                Nuestra empresa
              </Typography>
            </Stack>
  
            <Grid container spacing={5} data-aos="fade-right" mb={5} alignItems="center">
              {/* Texto */}
              <Grid item xs={12} md={6}>
                <Box sx={{ maxWidth: 720 }}>
                  <Typography
                    variant="body1"
                    sx={{ color: "rgba(0,0,0,0.72)", fontWeight: 400, lineHeight: 1.7, textAlign: "justify" }}
                  >
                    Laboratorio Sertex SRL asume la responsabilidad de crecer y desarrollar el compromiso de la calidad y la
                    satisfacción del cliente, compatibles con las normas sanitarias y la ética profesional.
                  </Typography>

                  <Typography
                    variant="subtitle1"
                    sx={{ color: theme.palette.primary.main, fontWeight: 700, mt: 3 }}
                  >
                    En Laboratorio Sertex SRL estamos comprometidos:
                  </Typography>

                  <List aria-label="about" sx={{ width: "100%", mt: 1 }}>
                    {dataLista.map((item) => (
                      <ListItem key={item.id} alignItems="flex-start" disableGutters sx={{ py: 0.5 }}>
                        <ListItemIcon sx={{ minWidth: 32, mt: 0.3 }}>
                          <CheckOutlinedIcon sx={{ color: theme.palette.primary.main }} aria-hidden />
                        </ListItemIcon>
                        <ListItemText
                          primary={item.texto}
                          primaryTypographyProps={{
                            variant: "body2",
                            sx: { color: "rgba(0,0,0,0.72)", fontWeight: 400, textAlign: "justify", lineHeight: 1.6 },
                          }}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </Grid>
  
              {/* Imagen + Play */}
              <Grid item xs={12} md={6} data-aos="fade-up" sx={{ display: "flex", justifyContent: "center" }}>
                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                    maxWidth: 560,
                    borderRadius: 2,
                    overflow: "hidden",
                    boxShadow: 3,
                  }}
                >
                  <IconButton
                    aria-label="Reproducir video institucional"
                    onClick={handleOpen}
                    sx={{
                      position: "absolute",
                      left: "50%",
                      top: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 2,
                      bgcolor: "rgba(255,255,255,0.9)",
                      "&:hover": {
                        bgcolor: "rgba(255,255,255,1)",
                        transform: "translate(-50%, -50%) scale(1.05)",
                      },
                      transition: "transform .2s ease",
                    }}
                  >
                    <PlayCircleOutline sx={{ fontSize: 64, color: theme.palette.primary.main }} />
                  </IconButton>
  
                  <Box
                    component="img"
                    src="/assets/images/fotoAbout.jpg"
                    alt="Equipo y planta de Laboratorio Sertex"
                    loading="lazy"
                    sx={{
                      display: "block",
                      width: "100%",
                      height: "auto",
                      aspectRatio: "16 / 9",
                      objectFit: "cover",
                      filter: "saturate(.95)",
                    }}
                  />
                </Box>
  
                {open && <ModalVideo open={open} handleClose={handleClose} />}
              </Grid>
            </Grid>
          </Container>
        </Box>
      </section>
    );
  };
  
  export default About;
  